import { inject, Injectable } from '@angular/core';
import { NotificationItem } from '@models/notifications';
import { ParsedApiError } from '@utils/api-error-message';
import { resolveText } from '@utils/notifications';
import { I18NextPipe } from 'angular-i18next';
import { MbsPopupType, Toast, ToastService } from 'mbs-ui-kit';
import { NotificationsService } from './notifications.service';

@Injectable()
export class ResellerToastService extends ToastService {
  private notifications = inject(NotificationsService);
  private i18n = inject(I18NextPipe);

  override toast(toast: Toast): void {
    if (typeof toast.content === 'string' && toast.content.trim()) {
      this.notifications.add({
        title: typeof toast.header === 'string' ? toast.header : '',
        message: toast.content,
        type: toast.type || MbsPopupType.info,
        date: new Date()
      });
    }

    if (this.notifications.muted()) {
      return;
    }

    super.toast(toast);
  }

  apiError(parsed: ParsedApiError, meta: Pick<NotificationItem, 'url' | 'status'>): void {
    this.notifications.add({ ...parsed, ...meta, type: MbsPopupType.danger, date: new Date() });

    if (this.notifications.muted()) {
      return;
    }

    // super.toast, not this.toast: the notification with url/status/i18n keys is already recorded above
    super.toast(
      new Toast({
        header: resolveText(parsed.title, parsed.titleKey, this.i18n),
        icon: true,
        content: resolveText(parsed.message, parsed.messageKey, this.i18n),
        type: MbsPopupType.danger
      })
    );
  }
}
